import { useLocation, matchPath } from 'react-router-dom'
import { routes } from './Routes'

export function useCaslModule(): string | null {
  const location = useLocation()

  const matchedRoute = routes.find((route) =>
    matchPath(location.pathname, {
      path: route.path,
      exact: true,
      strict: false,
    })
  )

  return matchedRoute?.casl || null
}
